import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M18.93 4.001q.027 0 .071.004.087.005.225.026c.178.03.427.09.683.219.26.13.54.336.753.656.217.325.338.728.338 1.203v12.796l-.001.025q0 .027-.004.071a2.4 2.4 0 0 1-.245.908c-.13.26-.336.54-.656.753-.325.217-.728.338-1.203.338H6.095l-.025-.001q-.027 0-.071-.004a2.4 2.4 0 0 1-.908-.245c-.26-.13-.54-.336-.753-.656C4.12 19.769 4 19.366 4 18.89V6.095l.001-.025q0-.027.004-.071.005-.087.026-.225c.03-.178.09-.427.219-.683.13-.26.336-.54.656-.753C5.231 4.12 5.634 4 6.11 4h12.796z"
    }, null, -1)
  ]))]))
}
export default { render: render }